import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { BubbleChart, ExpandLess, ExpandMore } from '@material-ui/icons';
import { Typography, ListItemText, ListItem, ListItemIcon } from '@material-ui/core';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex'
    },
    appBar: {
        backgroundColor: '#1CBBC1',
        borderRadius: '0 0 30px 30px',
        boxShadow: '0 4px 5px 0 rgba(0,0,0,0.83)',
        minHeight: '174px',
        justifyContent: 'center',
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        margin: '12px',
        display: 'flex',
        alignItems: 'start',
        height: '26px',
        padding: '0px',
        marginTop: '0px',
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        '& .MuiDrawer-paper': {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
        }
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        padding: theme.spacing(0, 1),
        flexShrink: 0,
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
        marginTop: '12rem',
        backgroundColor: '#FFF',
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
    active: {
        background: '#CCD1D1',
        color: '#3498DB'
    }
}));

const IconProfileTypography = withStyles((theme) => ({
    root: {
        height: '62px',
        width: '62px',
    },
}))(Typography)

const IconMenuTypography = withStyles((theme) => ({
    root: {
        height: '33px',
        width: '28px',
    },
}))(Typography)

const IconMenuSmallTypography = withStyles((theme) => ({
    root: {
        height: '33px',
        width: '34px',
    },
}))(Typography)

const useStylesMenu = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: 240,
        flex: '1 1 auto',
        minHeight: 0,
        overflowY: 'auto',
    },
    lists: {
        backgroundColor: theme.palette.background.paper,
        marginTop: theme.spacing(1),
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    submenu: {
        paddingTop: theme.spacing(2),
    }
}));

const breadcrumbNameMap = {
    '/requisiciones/pendientes': 'Autorizar', //Por autorizar
    '/requisiciones/aprobadas': 'Aprobadas',
    '/requisiciones/pasadas': 'Pagados',
    '/nuevaRequisicion': 'Nueva requisición',
    '/pagos/pendientes': 'Pendiente', //Por pagar
    '/pagos/pasados': 'Pasados',
    '/pagoMultiple': 'Múltiple', //Pago multiple
    '/autorizacionMultiple': 'Autorización masiva',//autorización múltiple
    '/proveedores/lista': 'Listado proveedores',
    '/proveedores/nuevo': 'Nuevo proveedor',
    '/cfdis/pendientes': 'Consultar',
    '/cfdis/pasados': 'Por cargar',
    '/soporte/solicitud': 'Solicitud',
    '/soporte/consulta': 'Consulta solicitudes',
    '/configuracion/cuentasEmisoras': 'Cuenta emisora',
    '/configuracion': 'Razones sociales',
    '/configuracion/cuentasNotificacion': 'Cuentas notificaciones',
    '/configuracion/cambiarContrasena': 'Cambiar contraseña'
};

function ListItemLink(props) {
    const { to, open, ...other } = props;
    const primary = breadcrumbNameMap[to];

    return (
        <li>
            <ListItem button component={RouterLink} to={to} {...other}>
                <ListItemText primary={primary} />
                {open != null ? open ? <ExpandLess /> : <ExpandMore /> : null}
            </ListItem>
        </li>
    );
}

function SecondaryItemLink(props) {
    const { to, open, ...other } = props;
    const primary = breadcrumbNameMap[to];

    return (
        <ListItem button component={RouterLink} to={to} {...other}>
            <ListItemIcon>
                <BubbleChart></BubbleChart>
            </ListItemIcon>
            <ListItemText primary={primary} />
            {open != null ? open ? <ExpandLess /> : <ExpandMore /> : null}
        </ListItem>
    );
}

function SetItem(props) {
    const { to, open, ...other } = props;
    const primary = breadcrumbNameMap[to];
    const location = useLocation();
    const classes = useStyles();

    return (
        <div className={location.pathname === Object.keys(breadcrumbNameMap)[props.idpath] ? classes.active : null}>
            <ListItem button component={RouterLink} to={to} {...other}>
                {props.iconname !== '' ?
                    <ListItemIcon>
                        <IconMenuTypography className={props.iconname} ></IconMenuTypography>
                    </ListItemIcon> : ''
                }
                <ListItemText primary={primary} />
                {open != null ? open ? <ExpandLess /> : <ExpandMore /> : null}
            </ListItem>
        </div>
    );
}

ListItemLink.propTypes = {
    open: PropTypes.bool,
    to: PropTypes.string.isRequired,
};

SecondaryItemLink.propTypes = {
    open: PropTypes.bool,
    to: PropTypes.string.isRequired,
};

export {
    useStyles, IconProfileTypography, IconMenuTypography, IconMenuSmallTypography,
    useStylesMenu, ListItemLink, SecondaryItemLink, SetItem
    //ListItemNuevaReq, ListItemAutorizarReq,
    // ListItemAutorizacionMasiva, ListItemReqAprobadas, ListItemPagoPendiente, ListItemPagoMultiple,
    // ListItemPagados, ListItemProveedoresLista, ListItemNuevoProveedor, ListItemCfdisPendientes,
    // ListItemCfdisPasados, ListItemNuevaSolicitud, ListItemConsultaSolicitudes,
    // ListItemCuentas, ListItemRazonesSociales, ListItemCuentasNotificacion, ListItemCambiarContrasena
}